<h1 mat-dialog-title>Switch User</h1>

<mat-dialog-content class="!pb-0">
  <div class="flex justify-around pb-5">
    <mat-form-field>
      <mat-label>Filter by name</mat-label>
      <input matInput [(ngModel)]="nameFilter" (ngModelChange)="filterByName($event)" />
    </mat-form-field>
    <mat-form-field>
      <mat-label>Filter by employee #</mat-label>
      <input matInput [(ngModel)]="numFilter" (ngModelChange)="filterByNumber($event)" />
    </mat-form-field>
    <mat-form-field>
      <mat-label>Filter by cost center</mat-label>
      <input matInput [(ngModel)]="ccFilter" (ngModelChange)="filterByCC($event)" />
    </mat-form-field>
  </div>

  <bar-select
    itemName="Users"
    class="approvers-list"
    innerClass="w-1/2 ml-[25%]"
    [items]="visibleShop"
    (itemChosen)="select($event)"
  />
</mat-dialog-content>
